<nav class="app-nav-bar navbar fixed-top navbar-expand-lg navbar-light">
	<div class="container-fluid">
		<a class="navbar-brand" [routerLink]="['/dashboard']">
			<img src="/assets/images/lmcredit.png" alt="LM Credit Logo" height="20" />
		</a>
		<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
			aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse" id="navbarSupportedContent">
			<ul class="navbar-nav me-auto mb-2 mb-lg-0" *ngIf="!isExternalView">
				<li class="nav-item dropdown" *ngIf="!isExternalCollector">
					<a class="nav-link dropdown-toggle" href="#" id="dashboardDropdown" role="button"
						data-bs-toggle="dropdown" aria-expanded="false">
						Dashboards
					</a>
					<ul class="dropdown-menu" aria-labelledby="dashboardDropdown">
						<li>
							<a class="dropdown-item" href="https://analytics.zoho.com/open-view/1377947000010209061"
								target="_blank">Sales
								Agent</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/underwritingdashboard']">Underwriting</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/rapid-files']">Rapid Files</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/dashboard/apps-conversion']">Apps Conversion</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/dashboard/calls']">Scheduled Calls</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/call-logs']"
								[queryParams]="{employeeType: 'FSR'}">Call logs (FSR)</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/dashboard/funding-list']">Funding List</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/dashboard/my-funded-deals']">My Funded Deals in Collection</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/dashboard/uw-daily-stat']">UW Performance</a>
						</li>
					</ul>
				</li>
				<li class="nav-item dropdown" *ngIf="!isExternalCollector">
					<a class="nav-link dropdown-toggle" href="#" id="fundingReportsDropdown" role="button"
						data-bs-toggle="dropdown" aria-expanded="false">
						Reports
					</a>
					<ul class="dropdown-menu" aria-labelledby="fundingReportsDropdown">
						<li>
							<a class="dropdown-item" *ngIf="collectionManagerReportComponentFlag"
								[routerLink]="['/reports']">Manager</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/nlsdashboard']">Today's Funding</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/nlsagencyfunded']">Funding Report</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/nlsagencycollections']">Agency</a>
						</li>
						<li class="dropdown-submenu">
							<a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
								href="#">Collections</a>
							<ul class="dropdown-menu">
								<li>
									<a class="dropdown-item"
										[routerLink]="['/reports/collections/payments-received']">Payments
										Received</a>
								</li>
							</ul>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/uw-performance']">UW Performance</a>
						</li>
						<li class="dropdown-submenu" *ngIf="adminReportFlag">
							<a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
								href="#">Admin Report</a>
							<ul class="dropdown-menu">
								<li>
									<a class="dropdown-item" [routerLink]="['/admin-reports/loan-staging']">Loan Staging</a>
								</li>
								<li>
									<a class="dropdown-item" [routerLink]="['/admin-reports/accrued-interest']">Accrued Interest</a>
								</li>
								<li>
									<a class="dropdown-item" [routerLink]="['/admin-reports/loan-group-transfer-accrued']">Loan Group Transfer Accrued</a>
								</li>
								<li>
									<a class="dropdown-item" [routerLink]="['/admin-reports/loan-movement']">Loan Movement</a>
								</li>
							</ul>
						</li>

					</ul>
				</li>
				<li class="nav-item dropdown"
					*ngIf="collectionListComponentFlag || userRoleID === 7 || isExternalCollector">
					<a class="nav-link dropdown-toggle" href="#" id="collectionReportsDropdown" role="button"
						data-bs-toggle="dropdown" aria-expanded="false">
						Collections
					</a>
					<ul class="dropdown-menu" aria-labelledby="collectionReportsDropdown">
						<li>
							<a class="dropdown-item" [routerLink]="['/collection-list']">My List</a>
						</li>
					</ul>
				</li>
				<li class="nav-item dropdown" *ngIf="!isExternalCollector">
					<a class="nav-link dropdown-toggle" href="#" id="applicationsDropdown" role="button"
						data-bs-toggle="dropdown" aria-expanded="false">
						Applications
					</a>
					<ul class="dropdown-menu" aria-labelledby="applicationsDropdown">
						<li>
							<a class="dropdown-item" [routerLink]="['/applications']">Applications</a>
						</li>
						<li>
							<a class="dropdown-item" (click)="openCreateApplicationModal()">Create</a>
						</li>
					</ul>
				</li>
				<li class="nav-item dropdown" *ngIf="ptpFinanceFlag">
					<a class="nav-link dropdown-toggle" href="#" id="loanServicingDropdown" role="button"
						data-bs-toggle="dropdown" aria-expanded="false">
						Loan Servicing
					</a>
					<ul class="dropdown-menu" aria-labelledby="loanServicingDropdown">
						<li>
							<a class="dropdown-item" [routerLink]="['/promise-to-pay']">Promises to Pay</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/funding-list']">Funding List</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/funding-list-mom']">Funding List MOM</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/report-queue']">Report Queue Config</a>
						</li>
						<li class="dropdown-submenu" *ngIf="loanServicingReportsFlag">
							<a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
								href="#">Reports</a>
							<ul class="dropdown-menu">
								<li>
									<a class="dropdown-item"
										[routerLink]="['/loan-servicing/reports/account-informations']">Account
										Informations</a>
								</li>
								<li>
									<a class="dropdown-item"
										[routerLink]="['/loan-servicing/reports/payment-breakdowns']">Payment
										Breakdowns</a>
								</li>
								<li>
									<a class="dropdown-item"
										[routerLink]="['/loan-servicing/reports/sanity-checks']">Sanity
										Checks</a>
								</li>
								<li>
									<a class="dropdown-item"
										[routerLink]="['/loan-servicing/reports/lpp-reports']">LPP</a>
								</li>
							</ul>
						</li>
						<li *ngIf="insuranceCancellationFlag">
							<a class="dropdown-item" [routerLink]="['/loan-servicing/insurance-cancellaction']">INS
								Cancellation</a>
						</li>
						<li *ngIf="financeNlsSettingFlag">
							<a class="dropdown-item" [routerLink]="['/loan-servicing/nls-setting']">NLS Setting</a>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/loan-servicing/payment-processing']">Payment
								Processing</a>
						</li>
						<li class="dropdown-submenu">
							<a class="dropdown-item dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
								href="#">Payment Receipts</a>
							<ul class="dropdown-menu">
								<li>
									<a class="dropdown-item"
										[routerLink]="['/loan-servicing/payment-receipts/create']">Create Payment
										Receipt</a>
								</li>
							</ul>
						</li>
						<li>
							<a class="dropdown-item" [routerLink]="['/loan-servicing/settings']">Settings</a>
						</li>
					</ul>
				</li>
				<li class="nav-item dropdown" *ngIf="adminDashboardFlag">
					<a style="font-size: 14px; padding: 4px" role="button" [routerLink]="['/admin-settings']">Admin
						Settings</a>
				</li>
			</ul>
			<ul class="navbar-nav me-auto mb-2 mb-lg-0" *ngIf="isExternalView">
				{{fullName}}
			</ul>
			<div class="me-2">
				<button mat-raised-button color="primary" (click)="openCreateApplicationModal()"
					style="font-size: 14px;" *ngIf="!isExternalView">
					<mat-icon>add</mat-icon>Create Application
				</button>
			</div>
			<div *ngIf="!isExternalView" class="d-flex search-container">
				<input readonly class="form-control" placeholder="Search" aria-label="Search" id="search-bar-input"
					(click)="onSearchClicked($event)" value="{{searchKeyword}}" />
			</div>

            <div class="me-2" id="logout">
                <a class="logout" [routerLink]="['/login']" (click)="logout()">Logout</a>
            </div>

            <div class="me-1 d-flex align-items-center">
                <button mat-button (click)="openEnvironmentInfoModal()" style="font-size: 14px;">
                    {{ appVersion }}
                </button>
                <mat-chip *ngIf="isNonProduction" class="env-chip" disableRipple>{{ environmentName }}</mat-chip>
            </div>
        </div>
    </div>
</nav>